export default "__VITE_ASSET__DQNvRn1L__"